import { useEffect } from 'react';

import { KeyboardKeys } from 'src/constants/shortcutConsts';
import useNavigate from 'src/hooks/useNavigate';
import { useAppSelector } from 'src/hooks/useStore';

interface Options {
  disabled?: boolean;
}

export const useEscNavigation = (
  target: string | (() => void),
  options?: Options,
) => {
  const { navigate } = useNavigate();
  const isFormPageChanged = useAppSelector(
    (state) => state.ui.isFormPageChanged,
  );

  useEffect(() => {
    const handleEsc = (event: KeyboardEvent) => {
      if (event.key !== KeyboardKeys.Esc) return;
      if (options?.disabled) return;
      if (typeof target === 'function') {
        target();
      } else {
        navigate(target);
      }
    };
    document.addEventListener('keydown', handleEsc);

    return () => {
      document.removeEventListener('keydown', handleEsc);
    };
  }, [isFormPageChanged, options, target]);
};
